import {createAsyncThunk} from "@reduxjs/toolkit";
import {handlerError} from "../../../store/handleError";
import {setModalMessage} from "../../messages/model/slice";
import {clientInvoiceAPI} from "../api";
import {
    ClientInvoiceStatus,
    IGetClientInvoicesQuery,
} from "../../../models/IClientInvoice";

// ── Клиент ────────────────────────────────────────────────────────────────

export const fetchIssueClientInvoice = createAsyncThunk(
    "client_invoice/issue",
    async (_, {rejectWithValue, dispatch}) => {
        try {
            return await clientInvoiceAPI.issue();
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchGetMyClientInvoices = createAsyncThunk(
    "client_invoice/get_my",
    async (_, {rejectWithValue}) => {
        try {
            return await clientInvoiceAPI.getMy();
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

// Запрос PDF идёт с responseType "blob", поэтому и тело ошибки — Blob:
// handlerError его не читает. Достаём message из JSON внутри blob.
const pdfErrorMessage = async (e: unknown): Promise<string> => {
    const data = (e as { response?: { data?: unknown } })?.response?.data;
    if (data instanceof Blob) {
        try {
            const body = JSON.parse(await data.text());
            const msg = Array.isArray(body?.message) ? body.message.join(', ') : body?.message;
            if (typeof msg === "string" && msg) return msg;
        } catch {
            // не JSON — ниже общий handlerError
        }
    }
    return handlerError(e);
};

export const fetchDownloadClientInvoicePdf = createAsyncThunk(
    "client_invoice/download_pdf",
    async (
        {id, number, isAdmin}: { id: string; number: string; isAdmin?: boolean },
        {rejectWithValue, dispatch},
    ) => {
        try {
            const blob = isAdmin
                ? await clientInvoiceAPI.downloadPdfAdmin(id)
                : await clientInvoiceAPI.downloadPdf(id);

            // Триггерим скачивание в браузере
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `Счёт_${number}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            return id;
        } catch (e) {
            const msg = await pdfErrorMessage(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

// ── Админ ─────────────────────────────────────────────────────────────────

export const fetchGetAllClientInvoices = createAsyncThunk(
    "client_invoice/get_all_admin",
    async (query: IGetClientInvoicesQuery | undefined, {rejectWithValue}) => {
        try {
            return await clientInvoiceAPI.getAllAdmin(query);
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

export const fetchUpdateClientInvoiceStatus = createAsyncThunk(
    "client_invoice/update_status",
    async (
        {id, status}: { id: string; status: ClientInvoiceStatus },
        {rejectWithValue},
    ) => {
        try {
            return await clientInvoiceAPI.updateStatus(id, status);
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);